module.exports = __webpack_public_path__ + "static/5-17f43bf1bb48fe52ce4e608afa5f1916.png";